<!--
 * =====================================================================
 * 작 업 명  : 회원ID 찾기
 * 파 일 명  : FindId.vue
 * 변경이력
 * 2022-01-29 / 정태화 / 최초작성
 * 2022-03-02 / 경다찬 / 디자인 변경 및 기능추가
 * =====================================================================
 -->
<template>
  <div>
    <div>
      <FindId1
          v-show="showStep1"
          :fromParams="fromParams"
          @submitEmail="findIdRequest"
      />

      <FindId2
          v-show="showStep2"
          :userId="foundUserId"
          :fromParams="fromParams"
          @back="goBack"
      />
    </div>
  </div>
</template>

<script>
import { $axios, $error, $global } from "@/dot-ui/index.js";
import FindId1 from "@/components/user/FindId1.vue";
import FindId2 from "@/components/user/FindId2.vue";

export default {
  components: { FindId1, FindId2 },
  data() {
    return {
      fromParams: {},
      foundUserId: "",
      showStep1: true,
      showStep2: false,
    };
  },
  created() {
    this.fromParams = $global.getUrlParams();
  },
  methods: {
    async findIdRequest(email) {
      const { s, c } = this.fromParams;
      const url = `/user-app/v2/users/id/find`;

      const response = await $axios.post(url, { EMAIL: email , SITE_NO: s, COMP_NO: c});

      if (response.status === 200) {
        const json = response.data;
        this.foundUserId = json.USER_ID ? json.USER_ID : "No matching username found.";
        this.showStep1 = false;
        this.showStep2 = true;
      } else {
        $error.showMessage(response, this);
      }
    },
    goBack() {
      this.showStep2 = false;
      this.showStep1 = true;
    }
  }
};
</script>

<style></style>